import React from 'react';
import CinematicPortal from '@/components/CinematicPortal';
import { useVideoPortal } from '@/contexts/VideoPortalContext';

const GlobalVideoPortal: React.FC = () => {
  const { isOpen, currentVideo, closeVideo } = useVideoPortal();

  React.useEffect(() => {
    if (currentVideo) {
      console.log('GlobalVideoPortal: Video opened', { isOpen, currentVideo });
    }
  }, [isOpen, currentVideo]);

  if (!currentVideo) return null;

  return (
    <CinematicPortal
      isOpen={isOpen}
      onClose={closeVideo}
      videoSrc={currentVideo.src}
      posterSrc={currentVideo.poster}
      title={currentVideo.title}
      aspectRatio={currentVideo.aspectRatio}
      sourcePage={currentVideo.sourcePage}
      sourceAction={currentVideo.sourceAction}
      showCTAOnEnd={currentVideo.showCTAOnEnd}
    />
  );
};

export default GlobalVideoPortal;